import React from 'react'

export default function Marca({ color, logoSrc, brand }) {
  return (
    <div className="w-full flex justify-center items-center">
      <div
        className="py-4 md:px-8 rounded-t-[10px] flex justify-center items-center w-[200px] md:w-[260px]"
        style={{ backgroundColor: color }}
      >
        <img
          src={logoSrc}
          alt="Logo"
          className={`h-8 md:h-10 w-full ${brand === 'projectiva' ? 'scale-145' : brand === 'behub' ? 'scale-100' : 'scale-180'}`}
        />
      </div>
    </div>
  )
}
